"use strict";
var Cache_1 = require('../Cache');
var MixinUtil_1 = require('../MixinUtil');
var SchemaStore = (function () {
    function SchemaStore() {
        // Cache impl
        this._cache = {};
    }
    return SchemaStore;
}());
exports.SchemaStore = SchemaStore;
MixinUtil_1.default.applyMixins(SchemaStore, [Cache_1.default]);
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = new SchemaStore();
